import { Box, Grid, GridProps, Typography } from '@mui/material';
import { useField } from 'formik';
import { TextField, TextFieldProps } from '../../../../../atomic/input/textField';
import { FormFieldWrapper } from '../../shared/formFieldWrapper';
import { useAdditionalOnChange } from '../hooks/useAdditionalOnChange';
import { FormFieldProps } from '../index';

export type FormTextFieldProps = FormFieldProps &
  Omit<TextFieldProps, 'onChange'> &
  Pick<GridProps, 'lg' | 'md' | 'sm' | 'xl' | 'xs'> & { errors?: string[] };

export const FormTextField = FormFieldWrapper<FormTextFieldProps>(
  ({ additionalOnChange, errors, ...rest }) => {
    const [field, meta] = useField<unknown>({
      name: rest.name,
      type: rest.type
    });

    const onChange = useAdditionalOnChange(field.onChange, additionalOnChange);

    return (
      <Grid item xs={rest.xs ?? 12} sm={rest.sm} md={rest.md} lg={rest.lg} xl={rest.xl}>
        <TextField
          {...rest}
          label={rest.label}
          type={rest.type}
          name={field.name}
          value={field.value}
          onChange={onChange}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          onBlur={field.onBlur}
        />
        {errors && (
          <Box p={1}>
            {errors.map((error) => {
              return (
                <Typography key={error} fontSize={12} color="error.main">
                  {error}
                </Typography>
              );
            })}
          </Box>
        )}
      </Grid>
    );
  }
);
